import { useCallback } from "react";
import { useSetPageState } from "state/hooks";
import { PAGE_STATE_ENUM } from "utils/enum";

const usePageState = () => {
    const { setPage } = useSetPageState()

    const activeHoverboardScreen = useCallback(() => {
        setPage ({activePage : PAGE_STATE_ENUM.HOVERBOARD})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const activeFromScreen = useCallback(() => {
        setPage ({activePage :PAGE_STATE_ENUM.FORMSCREEN})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const activePaymentScreen = useCallback(() => {
        setPage ({activePage :PAGE_STATE_ENUM.PAYMENT})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const activeConfrimScreen = useCallback(() => {
        setPage ({activePage :PAGE_STATE_ENUM.CONFORMATION})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



  return { activeHoverboardScreen , activeFromScreen, activePaymentScreen, activeConfrimScreen};
};

export default usePageState;
